import { __zcFin, __zcFinZ, __zcMkv, __zcPs } from "__zod-compiler-runtime__";
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'
import {BreadcrumbSchema} from './breadcrumb'

/**
 * Payload schema for individual resource detail pages.
 */
export const ResourceDetailsPayloadSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    breadcrumbLinks: safeOptional(z.array(BreadcrumbSchema)),
    indexPath: z.string().optional(),
  }),
);
var __rf=[__zs._zod.innerType.shape["breadcrumbLinks"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_2={};
var __rfn_8=__rf[0];
function __vb_12(input){var __bv_3,__bs_4,__bv_5,__bv_6,__bx_7,__bw_9,__bv_10,__bo_11;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_3=input["contentfulRawJsonResponse"];if(!(typeof __bv_3==="object"&&__bv_3!==null&&!Array.isArray(__bv_3)))return __bf_2;__bs_4=__zcPs(__bv_3);__bv_5=input["userLoggedIn"];if(!((__bv_5===undefined||(typeof __bv_5==="boolean"))))return __bf_2;__bv_6=input["breadcrumbLinks"];if(__bv_6===undefined){__bw_9=undefined;}else{__bx_7=__rfn_8(__bv_6);__bw_9=__bx_7;}__bv_10=input["indexPath"];if(!((__bv_10===undefined||(typeof __bv_10==="string"))))return __bf_2;__bo_11={"contentfulRawJsonResponse":__bs_4};if(__bv_5!==undefined||("userLoggedIn" in input)){__bo_11["userLoggedIn"]=__bv_5;}if(__bw_9!==undefined||("breadcrumbLinks" in input)){__bo_11["breadcrumbLinks"]=__bw_9;}if(__bv_10!==undefined||("indexPath" in input)){__bo_11["indexPath"]=__bv_10;}return __bo_11;}
var __rfm_z=__zs.safeParse;
function safeParse_ResourceDetailsPayloadSchema(input){
var __bd_13=__vb_12(input);
if(__bd_13!==__bf_2){return{success:true,data:__bd_13};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_ResourceDetailsPayloadSchema,__zs,null,null);
})()

export type ResourceDetailsPayload = z.infer<typeof ResourceDetailsPayloadSchema>

export function toResourceDetailsPayload(payload: unknown): ResourceDetailsPayload {
  return ResourceDetailsPayloadSchema.parse(payload)
}
